// All-brands common
import commonView from "../../../../../lib/yg/js/components/commonView"
import pipeHeader from "../../../../../lib/common/js/components/pipeHeader"
import pipeFooter from "../../../../../lib/common/js/components/pipeFooter"
import getPipeHeaderConfig from "./getPipeHeaderConfig"
import optionsForm from "../../../../../lib/yg/js/components/optionsForm"
import heightForm from "../../../../../lib/yg/js/components/heightForm"
import weightForm from "../../../../../lib/yg/js/components/weightForm"
import targetWeightForm from "../../../../../lib/yg/js/components/targetWeightForm"
import loadingProgress from "../../../../../lib/common/js/components/loadingProgress"
import bmi from "../../../../../lib/common/js/components/bmi"
import animations from "../../../../../lib/common/js/components/animations"
import animationsLoaders from "./animationsLoaders"
import slider from "../../../../../lib/common/js/components/slider"
import timer from "../../../../../lib/common/js/components/timer"
import sticky from "../../../../../lib/yg/js/components/sticky"
import faq from "../../../../../lib/common/js/components/faq"
import primer from "../../../../../lib/yg/js/components/primer"
import commonBasicPlanCheckout from "../../../../../lib/yg/js/components/commonBasicPlanCheckout"
import commonPaymentsBlock from "../../../../../lib/common/js/components/commonPaymentsBlock"
import commonUpsell from "../../../../../lib/yg/js/components/commonUpsell"
import cookieConsent from "../../../../../lib/common/js/components/cookieConsent"
import exitIntentListener from "../../../../../lib/yg/js/components/exitIntentListener"

// Brand-specific
import potential from "../../../../../lib/yg/js/components/potential"
import email from "../../../../../lib/yg/js/components/email"
import privacyAgreement from "../../../../../lib/yg/js/components/privacyAgreement"
import brandBasicPlanCheckout from "../../../../../lib/yg/js/components/brandBasicPlanCheckout"
import commonBasicPlanThankYou from "../../../../../lib/yg/js/components/commonBasicPlanThankYou"
import upsellPremium from "../../../../../lib/yg/js/components/upsellPremium"
import upsellShoppingList from "../../../../../lib/yg/js/components/upsellShoppingList"
import upsellShoppingListAndPremium from "../../../../../lib/yg/js/components/upsellShoppingListAndPremium"
import upsellChat from "../../../../../lib/yg/js/components/upsellChat"
import sendOff from "../../../../../lib/yg/js/components/sendOff"

// New AC flow JS
import paymentFailed from "./paymentFailed"
import apiDietSingleOfferCheckout from "../../../../../lib/yg/js/components/apiDietSingleOfferCheckout"
import apiDietBasicPlanThankYou from "../../../../../lib/yg/js/components/apiDietBasicPlanThankYou"
import apiDietUpsellPremium from "../../../../../lib/yg/js/components/apiDietUpsellPremium"
import apiDietUpsellShoppingList from "../../../../../lib/yg/js/components/apiDietUpsellShoppingList"
import apiDietUpsellChat from "../../../../../lib/yg/js/components/apiDietUpsellChat"
import apiDietUpsellShoppingListAndPremium from "../../../../../lib/yg/js/components/apiDietUpsellShoppingListAndPremium"

// Components hierarchy and reusage approach:
// Components are defined on 3 different levels depending on the scope of their usage:
// - All-brands common components are placed in the `lib/common/js/components/`.
// - The brand-specific common for all the given brand's series are placed in `lib/[brand]/js/components`.
// - The exact series specific ones are placed here in `src/[brand]-[series]/src/js/components`.
// This array defines the list of components for this exact series by combining them picked
// from different levels to stay DRY and flexible at the same time.
export default [
  { name: "view", data: commonView },
  { name: "pipeHeader", data: pipeHeader(getPipeHeaderConfig(pipelineConfig.variant)) },
  { name: "pipeFooter", data: pipeFooter },
  { name: "optionsForm", data: optionsForm(commonView) },
  { name: "heightForm", data: heightForm(commonView) },
  { name: "weightForm", data: weightForm(commonView) },
  { name: "targetWeightForm", data: targetWeightForm(commonView) },
  { name: "loadingProgress", data: loadingProgress },
  { name: "bmi", data: bmi },
  { name: "animations", data: animations(animationsLoaders) },
  { name: "slider", data: slider },
  { name: "timer", data: timer },
  { name: "sticky", data: sticky },
  { name: "faq", data: faq },
  { name: "cookieConsent", data: cookieConsent },
  { name: "potential", data: potential },
  { name: "email", data: email(commonView) },
  { name: "privacyAgreement", data: privacyAgreement },
  { name: "basicPlanSelection", data: brandBasicPlanCheckout(commonBasicPlanCheckout) },
  { name: "basicPlanPayments", data: brandBasicPlanCheckout(commonBasicPlanCheckout) },
  { name: "paymentsBlock", data: commonPaymentsBlock },
  { name: "primer", data: primer },
  { name: "basicPlanThankYou", data: commonBasicPlanThankYou },
  { name: "upsellPremium", data: upsellPremium(commonUpsell) },
  { name: "upsellShoppingList", data: upsellShoppingList(commonUpsell) },
  { name: "upsellShoppingListAndPremium", data: upsellShoppingListAndPremium(commonUpsell) },
  { name: "upsellChat", data: upsellChat(commonUpsell) },
  { name: "exitIntentListener", data: exitIntentListener },
  { name: "paymentFailed", data: paymentFailed(commonView) },
  { name: "apiDietSingleOfferCheckout", data: apiDietSingleOfferCheckout(commonBasicPlanCheckout) },
  { name: "apiDietBasicPlanThankYou", data: apiDietBasicPlanThankYou },
  { name: "apiDietUpsellPremium", data: apiDietUpsellPremium(commonUpsell) },
  { name: "apiDietUpsellShoppingList", data: apiDietUpsellShoppingList(commonUpsell) },
  { name: "apiDietUpsellChat", data: apiDietUpsellChat(commonUpsell) },
  { name: "sendOff", data: sendOff },
  {
    name: "apiDietUpsellShoppingListAndPremium",
    data: apiDietUpsellShoppingListAndPremium(commonUpsell),
  },
]
